import * as React from 'react'

export const ApplyLinkIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.24888 15.4837L21.6787 1.84242L24 4.12775L8.27535 20.1L0 11.8849L2.29495 9.57311L8.24888 15.4837Z'
        fill='currentColor'
      />
    </svg>
  )
})

ApplyLinkIcon.displayName = 'ApplyLinkIcon'
